import * as ApiManager from '../_manager';

export const adminPage = {
  list: (payload) => {
    return ApiManager.callApi(`/admin/page/list`, payload);
  },
  get: (payload) => {
    return ApiManager.callApi(`/admin/page/${payload.page_id}`, );
  },
  update: (payload) => {
    return ApiManager.callApi(`/admin/page/update`, payload);
  },
};
